export default {
      id: "slack-usage",
      viewBox: "0 0 448 512",
      url: __webpack_public_path__ + "img/svg.c2d72070.svg#slack",
      toString: function () {
        return this.url;
      }
    }